/* VitaBalance — agregar al carrito vía AJAX y abrir el cart drawer de Dawn */
(function () {
  'use strict';
  window.vbAddToCart = function (variantId, quantity, button, extraItems) {
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }].concat(extraItems || []), sections: sections.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) { alert(res.description); return; }
        var item = res.items ? res.items[0] : res;
        if (button && button.getAttribute('data-vb-checkout') === 'true') { window.location.href = '/checkout'; return; }
        document.dispatchEvent(new CustomEvent('cart:change', { detail: res }));
        if (drawer && drawer.renderContents && res.sections) {
          drawer.renderContents({ id: item.id, key: item.key, sections: res.sections });
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); } });
  };
})();
